export default "__VITE_PUBLIC_ASSET__ae5db781__"